var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    { staticClass: "pa-4", attrs: { outlined: "", elevation: "1" } },
    [
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  "hide-details": "auto",
                  type: "date",
                  label: "Date",
                  outlined: "",
                  dense: "",
                  max: _setup.today
                },
                model: {
                  value: _setup.formState.date,
                  callback: function($$v) {
                    _vm.$set(_setup.formState, "date", $$v)
                  },
                  expression: "formState.date"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "3" } },
            [
              _c("v-select", {
                attrs: {
                  items: _setup.shifts,
                  label: "Shift",
                  outlined: "",
                  dense: "",
                  "hide-details": "auto"
                },
                model: {
                  value: _setup.formState.shift,
                  callback: function($$v) {
                    _vm.$set(_setup.formState, "shift", $$v)
                  },
                  expression: "formState.shift"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "2" } },
            [
              _c("v-text-field", {
                attrs: {
                  "hide-details": "auto",
                  type: "time",
                  step: "1",
                  label: "Time In",
                  outlined: "",
                  dense: ""
                },
                model: {
                  value: _setup.formState.time_in,
                  callback: function($$v) {
                    _vm.$set(_setup.formState, "time_in", $$v)
                  },
                  expression: "formState.time_in"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "2" } },
            [
              _c("v-text-field", {
                attrs: {
                  "hide-details": "auto",
                  type: "time",
                  step: "1",
                  label: "Time Out",
                  outlined: "",
                  dense: ""
                },
                model: {
                  value: _setup.formState.time_out,
                  callback: function($$v) {
                    _vm.$set(_setup.formState, "time_out", $$v)
                  },
                  expression: "formState.time_out"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "2" } },
            [
              _c("v-text-field", {
                attrs: {
                  "hide-details": "auto",
                  type: "time",
                  step: "1",
                  label: "OT In",
                  outlined: "",
                  dense: ""
                },
                model: {
                  value: _setup.formState.ot_in,
                  callback: function($$v) {
                    _vm.$set(_setup.formState, "ot_in", $$v)
                  },
                  expression: "formState.ot_in"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "2" } },
            [
              _c("v-text-field", {
                attrs: {
                  "hide-details": "auto",
                  type: "time",
                  step: "1",
                  label: "OT Out",
                  outlined: "",
                  dense: ""
                },
                model: {
                  value: _setup.formState.ot_out,
                  callback: function($$v) {
                    _vm.$set(_setup.formState, "ot_out", $$v)
                  },
                  expression: "formState.ot_out"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "4" } },
            [
              _c("v-text-field", {
                attrs: {
                  "hide-details": "auto",
                  label: "OT Reason",
                  outlined: "",
                  dense: ""
                },
                model: {
                  value: _setup.formState.ot_reason,
                  callback: function($$v) {
                    _vm.$set(_setup.formState, "ot_reason", $$v)
                  },
                  expression: "formState.ot_reason"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "d-flex align-center",
              attrs: { cols: "12", md: "3" }
            },
            [
              _c("v-switch", {
                staticStyle: { "margin-top": "0" },
                attrs: {
                  dense: "",
                  label: "Meal Allowance",
                  "hide-details": ""
                },
                model: {
                  value: _setup.formState.has_meal_allowance,
                  callback: function($$v) {
                    _vm.$set(_setup.formState, "has_meal_allowance", $$v)
                  },
                  expression: "formState.has_meal_allowance"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "2" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    block: "",
                    loading: _setup.isSaving
                  },
                  on: { click: _setup.submit }
                },
                [_vm._v(" Save ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }